import { render, staticRenderFns } from "./vr.vue?vue&type=template&id=2d71b5b5&scoped=true&"
import script from "./vr.vue?vue&type=script&lang=js&"
export * from "./vr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71b5b5",
  null
  
)

export default component.exports